
import { Component, Vue } from 'vue-property-decorator'
import CourseOccupy from '../../components/course/course-occupy.vue'
import DeleteOccupy from '../../components/course/delete-occupy.vue'
import InquiryOccupy from '../../components/course/inquiry-occupy.vue'
import AddList from '../../components/course/add-list.vue'
import AddListBusiness from '../../components/course/add-list-business.vue'
import { UserModule } from '../../store/modules/user'
import { CourseModule } from '../../store/modules/course'
import { formatDate, learnStatus } from '../../utils/publish'
import HistoryNoSign from '../../components/course/history-no-sign.vue'
import StudentInfo from '../../components/studentDeatil/student-info.vue'
import EmployeeInfo from '../../views/employee/detail.vue'
import TableSign from '../../components/course/table-sign.vue'
import TableNoSign from '../../components/course/table-no-sign.vue'
import ReserveCourse from '../../components/course/reserve-course.vue'
import CourseRecord from '../../components/course/course-record.vue'


@Component({
    name: 'tables',
    components: { CourseOccupy, DeleteOccupy, AddList, AddListBusiness, HistoryNoSign, StudentInfo, EmployeeInfo, TableSign, TableNoSign, InquiryOccupy, ReserveCourse, CourseRecord }
})
export default class extends Vue {
    cssVar(status){
        const _statusColor = {
            3: "white",
            4: "#335bfc",
            5: "#07af04",
            6: "#767676"
        }
        const statusColor = _statusColor[status]
        return {
            "--color": statusColor,
            "height": '10px',
            "line-height": '0px'
        }
    }
    async getFirstCampus() {
        const res: any = await UserModule.getCampus({ types: 'info', org_id: this.org_id })
        if (res.code === 200) {
            let campus_id = res.data.campus_id
            if (this.userHistoryObj.campus_id) {
                campus_id = this.userHistoryObj.campus_id
            }
            this.getSchool(campus_id)
        }
    }
    getTime(val, type) {
      return formatDate(val, type)
    }
    getTeacherDeatils(val) {
        this.employee_info_id = val.id
        this.is_show_employee_info = true
    }
    closeEmployee() {
        this.is_show_employee_info = false
    }
    async getBusinessData(business_id) {
        const res: any = await CourseModule.getBusinessDetails({ business_id: business_id, is_show: 1 })
        if (res.code === 200) {
            this.business_itemValue = res.data[0]
            this.dialogBusinessAdd = true
        }
    }
    getBusinessDetail(val) {
        this.getBusinessData(val.business_id)
    }

    goStudentDetail(val) {
        this.student_info_id = val.student_id
        this.is_show_student_info = true
    }
    closeStudent(val) {
        if (val) {
            this.is_show_student_info = true
        } else {
            this.is_show_student_info = false
        }

    }
    closeRecord(val) {
        if (val) {
            this.is_show_course_record_info = true
        } else {
            this.is_show_course_record_info = false
        }

    }
    getColor(type) {
        return learnStatus(type)
    }

    async getSchool(campus_id) {
        const res: any = await UserModule.getCampus({ types: 'campus', org_id: this.org_id })
        if (res.code === 200 && res.data.list) {
            this.campus = res.data.list
            if (this.campus.length > 0) {
                for (var i = 0; i < this.campus.length; i++) {
                    if (this.campus[i].campus_id == campus_id) {
                        this.campusSelect = this.campus[i].campus_name
                        this.employee = this.campus[i].values
                        this.campusId = this.campus[i].campus_id
                        if (this.userHistoryObj.teacher_employee_id) {
                            if (this.userHistoryObj.teacher_employee_id.includes(',')) {
                                this.employeeSelect = this.userHistoryObj.teacher_employee_id.split(',')
                            } else {
                                this.employeeSelect.push(this.userHistoryObj.teacher_employee_id)
                            }
                        }
                    }
                }
            }
            this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        }
    }
    async getAllSchool() {
        const res: any = await UserModule.campusClassroom({ org_id: this.org_id, campus_id: '' })
        if (res.code === 200) {
            this.allSchool = res.data.list
        }
    }
    async getInstrument() {
        const instrument: any = await UserModule.getInstrument({ org_id: this.org_id })
        if (instrument.code === 200 && instrument.data.list && instrument.data.list.length > 0) {
            this.instrument = instrument.data.list
            if (this.userHistoryObj.instrument_type_id) {
                if (this.userHistoryObj.instrument_type_id.includes(',')) {
                    this.instrumentSelect = this.userHistoryObj.instrument_type_id.split(',')
                } else {
                    this.instrumentSelect.push(this.userHistoryObj.instrument_type_id)
                }
            }
        }
    }
    async getList(campusId, teacherEmployeeId, instrumentTypeId, startTime) {
        if (!startTime) {
            startTime = 0
        } else {
            startTime = startTime / 1000
        }
        const course = await UserModule.getCourse({ org_id: this.org_id, campusId: campusId, teacherEmployeeId: teacherEmployeeId, instrumentTypeId: instrumentTypeId, startTime: startTime, hidden_data: this.hiddenData })
        this.tableData = course.data.list
        this.total_course_title = course.data.total
        for (var i = 0; i < this.tableData.length; i++) {
            for (var j = 0; j < this.tableData[i].values.list.length; j++) {
                if (this.tableData[i].values.list[j].class_hours === 2) {
                    this.tableData[i].values.list[j + 1].class_hours = 9
                } else if (this.tableData[i].values.list[j].class_hours === 3) {
                    this.tableData[i].values.list[j + 1].class_hours = 9
                    this.tableData[i].values.list[j + 2].class_hours = 9
                }
            }
        }

        this.gethebingArr()
        this.loading = false
    }
    async getBaseCourse() {
        const res: any = await UserModule.getBaseCourse({ org_id: this.org_id, campus_id: this.addCourseCampusId })
        if (res.code === 200) {
            this.baseCourselist = res.data.list
            // 获取上次缓存课程种类和课程名数据
            this.getCacheBaseCourse(this.teacherId)
            // 判断是否存在课程种类
            let is_have_id = this.baseCourselist.find((value, index, arr) => {
                console.log(this.selectBaseCourse, value.course_type_id === this.selectBaseCourse, 'find')
                return value.course_type_id === this.selectBaseCourse
            })
            console.log(is_have_id, 'is_have_id')
            if (is_have_id) {
                for (var i = 0; i < this.baseCourselist.length; i++) {
                    if (this.baseCourselist[i].course_type_id === this.selectBaseCourse) {
                        this.courseTitleList = this.baseCourselist[i].values
                        let is_have_course_id = this.courseTitleList.find((value, index, arr) => {
                            return value.id === this.courseTitleId
                        })

                        if (is_have_course_id) {
                            for (var j = 0; j < this.courseTitleList.length; j++) {
                                if (this.courseTitleList[j].id === this.courseTitleId) {
                                    this.zsk_student_count = this.courseTitleList[j].student_count
                                }
                            }
                        } else {
                            this.courseTitleId = ''
                            this.zsk_student_count = 0
                        }
                        this.changeBaseCourse(this.selectBaseCourse)
                        this.getCacheBaseCourse(this.teacherId)
                    }
                }
            } else {
                this.selectBaseCourse = ''
                this.courseTitleId = ''
                this.courseTitleList = []
                this.zsk_student_count = 0
            }
        }
    }
    async getUserHistory() {
        const res: any = await UserModule.userHistory()
        if (res.code === 200) {
            this.userHistoryObj = res.data
            this.teacherEmployeeId = this.userHistoryObj.teacher_employee_id
            this.instrumentTypeId = this.userHistoryObj.instrument_type_id
            this.getInstrument()
            this.getFirstCampus()
        }
    }
    async option() {
        const res: any = await CourseModule.options({ optionId: this.optionId, org_id: this.org_id })
        if (res.code === 200) {
            this.optionList = res.data
            this.dialogAdd = true
        }
    }
    async businessOption() {
        const res: any = await CourseModule.options({ optionId: this.business_optionId, org_id: this.org_id })
        if (res.code === 200) {
            this.business_optionList = res.data
        }
    }
    async orderOption() {
        const res: any = await CourseModule.options({ optionId: this.order_optionId, org_id: this.org_id })
        if (res.code === 200) {
            this.order_optionList = res.data
        }
    }
    async getCustomrList() {
        const res: any = await CourseModule.customerPage({ org_id: this.org_id })
        if (res.code === 200) {
            let header = res.data.page_section[0].entity.entity_fields
            this.modifyHeader = []
            for (var i = 0; i < header.length; i++) {
                const existsType: string = header[i].exists_type
                if (existsType.indexOf('modify') >= 0) {
                    this.modifyHeader.push(header[i])
                }
            }
            this.optionId = res.data.page_section[0].entity.id
            this.pageName = res.data.key
            this.allData = res.data
            this.option()
        }
    }

    async addOrderSuccess(val) {
        if (val) {
            this.handleStkSignTrue()
        }
        this.dialogOrderAdd = false
    }

    async getOrderList() {
        const res: any = await CourseModule.orderPage({ org_id: this.org_id })
        if (res.code === 200) {
            let header = res.data.page_section[0].entity.entity_fields
            this.order_modifyHeader = []
            for (var i = 0; i < header.length; i++) {
                const existsType: string = header[i].exists_type
                if (existsType.indexOf('modify') >= 0) {
                    this.order_modifyHeader.push(header[i])
                }
            }
            this.order_optionId = res.data.page_section[0].entity.id
            this.order_allData = res.data
            this.orderOption()
        }
    }

    async getBusinessList() {
        const res: any = await CourseModule.businessPage({ org_id: this.org_id })
        if (res.code === 200) {
            let header = res.data.page_section[0].entity.entity_fields
            this.business_modifyHeader = []
            for (var i = 0; i < header.length; i++) {
                const existsType: string = header[i].exists_type
                if (existsType.indexOf('modify') >= 0) {
                    this.business_modifyHeader.push(header[i])
                }
            }
            this.business_optionId = res.data.page_section[0].entity.id
            this.business_pageName = res.data.key
            this.business_allData = res.data
            this.businessOption()
        }
    }

    getBusinessDetails(val) {
        this.dialogBusinessAdd = false
    }
    addSuccess(val) {
        if (val.type === 'true') {
            let res = {
                data: {
                    id: val.customer_id
                }
            }
            this.getBusinessList()
            this.getCustomerList(res)
        }
        this.dialogAdd = false
    }
    async mounted() {
        window.addEventListener("keyup", this.handleKeydown)
        this.getHeight()
        this.getUserHistory()
        this.getBusinessList()
        this.getOrderList()
        this.getAllSchool()
    }
    getHeight() {
        window.onresize = () => {
            this.tableHeight = window.innerHeight - 170
        }
    }

    // 添加占用 试听课 正式课方法
    async addCurriculum(data) {
        data.teacher_employee_id = this.teacherId
        data.org_id = this.org_id
        const res: any = await UserModule.curriculum(data)
        if (res.code === 200) {
            this.$message({ message: '添加成功', type: 'success' })
            this.handleClose()
            this.handleZshClose()
            this.handleStkClose()
            this.defaultStk()
            this.defaultZsk()
            this.handleShowStkClose()
            this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        } else {
            this.$message({
                duration: 5000,
                message: res.message,
                type: 'error'
            })
        }
    }
    // 添加试听课默认参数
    defaultStk() {
        this.edit = true
        this.isDelete = false
        this.getStkDesc = ''
        this.classRoomFirst = ''
        this.classroomId = ''
        this.getPeople = ''
        this.sale_employee_id = ''
        this.customer = ''
        this.customerId = ''
        this.business = ''
        this.businessId = ''
    }
    // 添加正式课默认参数
    defaultZsk() {
        this.edit = true
        this.isStudent = false
        this.isDelete = false
        this.createLabel = '1'
        this.selectBaseCourse = ''
        this.courseTitle = ''
        this.courseTitleId = ''
        this.classRoomFirst = ''
        this.classroomId = ''
        this.zskStudent = []
        this.zskRemark = ''
        this.classLevelId = ''
        this.classLevel = ''
        this.zskSubscript = ''
        this.dialogAddZsk = false
        this.materialSelect = []
        this.createCourse = '1'
        this.zskWeekDay = []
        this.setZskDate = []
        this.studentIds = []
    }
    // 监听校区
    campusChange(val) {
        this.loading = true
        this.employee = []
        this.employeeSelect = []
        this.teacherEmployeeId = ''
        this.getEmployee(val)
        this.campusId = val
        let obj: any = {}
        obj = this.campus.find((item) => {
            return item.campus_id === val
        })
        this.campusSelect = obj.campus_name
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    addCourseCampusChange(val) {
        this.addCourseCampusId = val
        this.getBaseCourse()
        this.getClassroom(this.addCourseCampusId)
    }
    addStkCampusChange(val) {
        this.addStkCampusId = val
        this.getClassroom(this.addStkCampusId)
    }
    // 获取老师
    getEmployee(id) {
        for (var i = 0; i < this.campus.length; i++) {
            if (this.campus[i].campus_id === id) {
                this.employee = this.campus[i].values
            }
        }
    }
    // 监听时间筛选
    getEduTime(val) {
        console.log(val, 'val')
        this.eduTime = val
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    // 隐藏空行
    handleHiddenData(val){
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        this.$nextTick(()=>{
            this.moveLast()
        })
    }
    handleKeydown(event){
        const keyList = ["a", "A", "q", "Q", "s", "S", "d", "D"]
        const keyboard = event.key
        if (!keyList.includes(keyboard)){
            return
        }
        if (event.repeat){
            return
        }
        if (event.isComposing || event.keyCode === 229) {
            return;
        }
        
        const todayTimestamp = Date.parse(<any>new Date())
        
        if (keyboard === 'q' || keyboard === 'Q'){
            this.hiddenData = this.hiddenData ? false : true
            this.$nextTick(()=>{
                this.moveLast()
            })
        } else if (keyboard === 'a' || keyboard === 'A'){
            // 今天
            this.eduTime = todayTimestamp
            this.$nextTick(() => {
                var idtoday = document.getElementById('idtoday')
                console.log(idtoday, 'idtoday')
                // Dom更新延迟使用settimeout
                if (idtoday){
                    // 页面聚焦到当天
                    idtoday.parentElement.parentElement.scrollIntoView();
                } else {
                    setTimeout(()=>{
                        var idtoday = document.getElementById('idtoday')
                        idtoday.parentElement.parentElement.scrollIntoView();
                    }, 400)
                }
            })
            
        } else if (keyboard === 's' || keyboard === 'S'){
            // 上周
            this.eduTime = this.eduTime - 3600 * 1000 * 24 * 7
        } else if (keyboard === 'd' || keyboard === 'D'){
            // 下周
            this.eduTime = this.eduTime + 3600 * 1000 * 24 * 7
        }
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    // 监听雇员
    employeeSChange(val) {
        this.loading = true
        let str: string = ''
        if (val.length === 1) {
            str = val[0]
            // 获取雇员昵称
            let obj: any = {}
            obj = this.employee.find((item) => {
                return item.id === val[0]
            })
        } else {
            str = val.toString()
        }
        this.teacherEmployeeId = str
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    // 监听乐器类型
    instrumentChange(val) {
        this.loading = true
        this.instrumentTypeId = val
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    // 表格合并方法-提供数组
    gethebingArr() {
        let obj: any = {}
        let arr: any = []
        this.rowArr = []
        this.tableData.forEach(function (item) {
            obj[item.day_time] ? (obj[item.day_time].count += 1) : obj[item.day_time] = { count: 1 }
        })
        for (let i in obj) {
            arr.push(obj[i].count)
        }
        for (let i = 0; i < arr.length; i++) {
            if (arr[i]) {
                this.rowArr.push(arr[i])
                for (var j = 0; j < arr[i] - 1; j++) {
                    this.rowArr.push(0)
                }
            } else {
                this.rowArr.push(0)
            }
        }
    }
    // 表格合并方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            const item = this.rowArr[rowIndex]
            return {
                rowspan: item,
                colspan: 1
            }
        } else {
            if (row.values && row.values.list[columnIndex - 2] && row.values.list[columnIndex - 2]['class_hours'] === 2) {
                return [1, 2]
            } else if (row.values && row.values.list[columnIndex - 2] && row.values.list[columnIndex - 2]['class_hours'] === 3) {
                return [1, 3]
            } else if (row.values && row.values.list[columnIndex - 2] && row.values.list[columnIndex - 2]['class_hours'] === 9) {
                return [0, 0]
            }
        }
    }
    // 创建课程时间戳
    getCreateTime(row, column, event, cell) {
        let timeStr: string = column.label
        this.teacherSelect = row.values.teacher_name
        this.teacherId = row.values.id
        let newTime = row.day_date.replace(/-/, '年').replace('-', '月') + '日'
        this.getSignInTime = newTime + ' ' + timeStr
        this.startHour = timeStr.split('-')[0].split(':')[0]
        let time: string = row.day_date
        this.clickTime = time + ' ' + timeStr
        timeStr = time + ' ' + timeStr.split('-')[0]
        this.startTime = Date.parse(timeStr) / 1000
    }
    cellStyle(row, column, cell, event){
        return ''
    }

    rowKey(row){
        return row.row_key
    }

    changeHightColumn(changed, _columnElement){
        // #f5f7fa
        for (var i = 0; i < _columnElement.length; i++){
            _columnElement[i].style.backgroundColor = changed
        }
    }
    moveLast(){
        var lastColumnElement = document.getElementsByClassName('el-table__cell')
        this.changeHightColumn('', lastColumnElement)
    }
    // 鼠标hover
    mouseHoverEnter(row, column, cell, event){
        this.moveLast()

        var _columnElement = document.getElementsByClassName(column.id)
        this.changeHightColumn('#f5f7fa', _columnElement)
    }
    mouseHoverLeave(row, column, cell, event){
        this.moveLast()
        var _columnElement = document.getElementsByClassName(column.id)
        this.changeHightColumn('', _columnElement)
    }
    // 关闭添加课程弹窗
    handleClose() {
        this.dialogVisible = false
    }
    // 去除占用弹窗取消
    handleZyClose() {
        this.dialogDeleteStk = false
    }

    // 去除占用弹窗确定
    handleZyTrue() {
        let data = {
            'course_id': this.deleteCourseId,
            'reason': this.deleteCourseReason
        }
        this.clearCourse(data)
    }
    // 添加占用弹窗
    alertOccupy() {
        this.typeOccupy = 'add'
        this.dialogAddZy = true
    }

    async selectCustomer(queryString, cb) {
        const res: any = await UserModule.getCustomer({ name: queryString, phone: queryString, org_id: this.org_id })
        if (res.code === 200) {
            let restaurants = res.data.list
            //  this.nowCustomer
            if (restaurants) {
                for (var i = 0; i < restaurants.length; i++) {
                    restaurants[i].value = restaurants[i].customer_name
                    this.businessId = ''  // 切换客户 商机id
                }
                cb(restaurants)
            }
        }
    }
    // 获取商机数据
    handleSelectBusiness(item) {
        this.customerId = item.customer_id
        this.selectBusiness = item.values
    }

    addStkTrue(type) {
        let data = {
            'campus_id': this.addStkCampusId,
            'start_time': this.startTime,
            'course_type': 2, // 1正式 2试听 3占用
            'customer_id': this.customerId,
            'business_id': this.businessId,
            'classroom_id': this.classroomId,
            'sale_employee_id': this.sale_employee_id,
            'remark': this.getStkDesc
        }
        if (this.customerId === '' || this.businessId === '' || this.startTime === 0 || this.teacherId === '' || this.sale_employee_id === '') {
            this.$message.error('请将数据填写完整')
            return false
        }
        if (type === 1) {
            this.addCurriculum(data)
        } else if (type === 2) {
            data['id'] = this.deleteCourseId
            this.editCourseMethod(data)
        }

    }
    // 添加试听课
    handleStkTrue() {
        if (this.isDelete) {
            this.addType = 'stk'
            this.deleteClass()
            return false
        }
        this.addStkTrue(1)
    }
    // 取消添加试听课
    handleStkClose() {
        this.dialogAddStk = false
        this.defaultStk()
    }

    // 获取校区及对应的教室
    async getClassroom(id) {
        const res: any = await UserModule.campusClassroom({ org_id: this.org_id, campus_id: id })
        if (res.code === 200) {
            if (res.data.list && res.data.list.length > 0) {
                this.classRoom = res.data.list[0].values
                const is_have_id = this.classRoom.find((value, index, arr) => {
                    return value.id === this.classRoomFirst
                })
                if (!is_have_id) {
                    this.classRoomFirst = ''
                }
            }
        }
    }

    // 获取人员数据
    async peopleList() {
        const res: any = await UserModule.getCampus({ types: 'list', org_id: this.org_id })
        if (res.code === 200) {
            this.getPeopleList = res.data.list
        }
    }
    // 约课正式课问询弹窗
    alertAppointmentCourse() {
        let str: string = ''
    }
    // 编辑试听课问询弹窗
    alertEditAuditionCourse() {
        this.editAudition()
    }
    // 编辑正式课问询弹窗
    alertEditAuditionClass() {
        let str: string = ''
        this.getStudent(str)
        this.editAuditionZsk()
    }
    // 显示当前课程历史预约
    alertCourseRecord(){
        console.log("alertcourserecord")
        this.is_show_course_record_info = true
    }
    // 约课弹窗
    async alertReserveCourse() {
        console.log('alertReserveCourse')
        this.dialogReserveCourse = true
        this.reserveCourseId = this.deleteCourseId
        // 获取当前排课课程
        const res: any = await CourseModule.getCourseByID({ course_id: this.deleteCourseId })
        if (res.code === 200) {
            this.courseObj = res.data
            if (this.courseObj.is_first) {
                this.selectBaseCourseID = this.courseObj.base_course_id
            } else {
                this.selectBaseCourseID = null
            }
            // 获取当前排课关联的基础课程
            this.baseCourseByCourseList = res.data.base_course_list
            for (var i = 0; i < this.courseTitleList.length; i++) {
                this.baseCourseByCourseList[i]['list_index'] = i + 1
            }
        }
    }
    reserveCourseClose(data) {
        console.log(data, 'data')
        this.dialogReserveCourse = false
        this.baseCourseByCourseList = []
        this.courseObj = {}
        this.selectBaseCourseID = null
        this.dialogDeleteStk = false
        this.dialogAddStk = false
        if (data.ctype == 2) {
            this.dialogShowStk = false
            this.dialogShowZsk = false
            this.dialogDeleteZsk = false
            this.dialogInquiryZy = false
            this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        }
    }

    // 监听商机筛选id
    businessChange(val) {
        this.businessId = val
    }
    // 监听上课教师id
    classRoomChange(val) {
        this.classroomId = val
    }
    // 监听销售人员筛选id
    peopleListChange(val) {
        this.sale_employee_id = val
    }
    // 创建正式课弹窗
    alertFormalCourse() {
        this.addCourseCampusId = this.campusId
        this.edit_show_student = true
        this.dialogAddZsk = true
        this.getBaseCourse()

        this.getClassroom(this.addCourseCampusId)
        this.peopleList()
        this.getCourseLevel()
    }
    // 监听课程种类 && 获取课程名
    changeBaseCourse(val) {
        let obj: any = {}
        obj = this.baseCourselist.find((item) => {
            return item.course_type_id === val
        })
        this.courseTitleList = obj.values
        this.courseTitleId = ''
    }
    // 监听课程名
    changeCourseTitle(val) {
        for (var i = 0; i < this.courseTitleList.length; i++) {
            if (this.courseTitleList[i].id === val[0]) {
                this.zsk_student_count = this.courseTitleList[i].student_count
            }
        }
        this.courseTitleId = val
    }

    // 学员列表查询
    async getStudent(query) {
        const res: any = await UserModule.studentIsCourse({ org_id: this.org_id, name: query, is_course: 1 })
        if (res.code === 200) {
            this.studentList = res.data.list
        }
    }
    // 获取课程等级
    async getCourseLevel() {
        const res: any = await UserModule.courseLevel({ org_id: this.org_id })
        if (res.code === 200) {
            this.courseLevelList = res.data.list
            if (this.edit_show_student) {  // 正式课编辑
                this.classLevelId = this.courseLevelList[0].id
                this.classLevel = this.courseLevelList[0].id
            }
        }
    }
    // 监听课程等级
    changeCourseLevel(val) {
        this.classLevelId = val
    }
    // 获取素材列表
    async getMaterial() {
        const res: any = await UserModule.material({ org_id: this.org_id, teacherEmployeeId: this.studentRowData.teacher_id, student_id: this.studentRowData.student_id })
        if (res.code === 200) {
            this.materialList = res.data.list
        }
    }
    // 监听正式课学员列表
    changeZskStudent(val) {
        let arr: any = []
        for (var i = 0; i < this.studentList.length; i++) {
            for (var j = 0; j < val.length; j++) {
                if (this.studentList[i].name == val[j]) {
                    arr.push(this.studentList[i].id)
                }
            }
        }
        this.studentIds = arr
    }

    //  正式课非体系课签到
    handleNotZskSignTrue(val) {
        if (val.type) {
            val.data['id'] = this.itemId
            this.signIn(val.data)
            this.dialogZskNoSystem = false
        } else {
            this.dialogZskNoSystem = false
        }
    }

    // 正式课弹窗关闭
    handleZshClose() {
        this.dialogAddZsk = false
        // this.handleClose()
        // this.handleStkClose()
        this.defaultStk()
        this.defaultZsk()
        // this.handleShowStkClose()
    }
    // 正式课提交方法
    addZskTrue(type) {
        let week_day: string = this.zskWeekDay.toString()
        if (this.createCourse == '1') {
            this.setZskDate = []
            this.course_number = 1
        }
        // 设置上课日期
        let time: any = this.setZskDate
        let start_date: any = ''
        let end_date: any = ''
        if (time && time.length > 0) {
            start_date = Date.parse(time[0]) / 1000
            end_date = Date.parse(time[1]) / 1000
        }

        // 是否仅学员可见
        let is_limit_student: number = 1
        if (this.isStudent) {
            is_limit_student = 1
        } else {
            is_limit_student = 2
        }

        // if(this.studentIds.length > this.zsk_student_count) {
        //     this.$message({
        //       message: '最多只能添加' + this.zsk_student_count + '个学生',
        //       type: 'warning'
        //     })
        //     return false
        // }

        let data = {
            'campus_id': this.addCourseCampusId,
            'start_time': this.startTime,
            'course_type': 1, // 1正式 2试听 3占用
            'is_limit_student': is_limit_student,
            'base_course_id': this.courseTitleId,
            'classroom_id': this.classroomId,
            'student_ids': this.studentIds,
            'start_hour': Number(this.startHour),
            'course_level_id': this.classLevelId,
            'remark': this.zskRemark,
            'subscript': this.zskSubscript,
            'start_date': Number(start_date),
            'end_date': Number(end_date),
            'week_day': week_day,
            'course_number': this.course_number
        }
        console.log(this.courseTitleId, 'titleid', this.addCourseCampusId, 'campusid', this.classLevelId, 'idssss')
        if (this.addCourseCampusId === '' || this.classLevelId === '') {
            this.$message.error('请将数据填写完整')
            return false
        }
        this.cacheBaseCourse(this.teacherId, this.selectBaseCourse, this.courseTitleId)
        if (type === 1) { // 新增
            this.addCurriculum(data)
        } else if (type === 2) {  // 编辑
            this.editCourse(data)
        }
    }
    cacheBaseCourse(teacherId, selectBaseCourse, courseTitleId) {
        //缓存老师上一次选中的课程种类以及课程名
        const val = [selectBaseCourse, courseTitleId]
        window.localStorage.setItem(teacherId, JSON.stringify(val))
    }
    getCacheBaseCourse(teacherId) {
        console.log(teacherId, 'teacherId')
        // 默认选择缓存中的课程种类和课程名
        const val = JSON.parse(window.localStorage.getItem(teacherId))
        console.log(val, 'val')
        if (val) {
            this.selectBaseCourse = val[0]
            this.courseTitleId = val[1]
        }
    }

    async editCourseMethod(data) {
        data.teacher_employee_id = this.teacherId
        data.org_id = this.org_id
        const res: any = await UserModule.editCourse(data)
        if (res.code === 200) {
            this.$message({ message: '编辑成功', type: 'success' })
            this.handleClose()
            this.handleZshClose()
            this.handleStkClose()
            this.defaultStk()
            this.defaultZsk()
            this.handleShowStkClose()
            this.dialogInquiryZy = false
            this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        } else {
            this.$message.error('编辑失败')
        }
    }
    editCourse(data) {
        data.id = this.deleteCourseId
        this.editCourseMethod(data)
    }

    // 正式课弹窗确认
    handleZshTrue() {
        if (this.isDelete) {
            this.addType = 'zsk'
            this.deleteClass()
            return false
        }
        this.addZskTrue(1)
    }
    // 试听课操作
    handleStk(val) {
        this.deleteCourseId = val.id
        this.getCourseSign()
        this.dialogShowStk = true
    }

    // 正式课操作
    handleZsk(val) {
        this.deleteCourseId = val.id
        this.getCourseSign()
        const start = formatDate(val.start_time, 3)
        const end = formatDate(val.end_time, 4)
        this.sign_title = start + '-' + end + '的课程进行签到'
        this.zsk_title = '正式课/' + val.class_room_name
        this.dialogShowZsk = true
    }


    // 正式课移除
    handleShowZskTrue() {
        this.dialogDeleteZsk = true
    }
    // 正式课移除弹窗close
    deleteZskClose() {
        this.dialogDeleteZsk = false
    }

    changeDeleteTime(val) {
        const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
        this.deleteZskDate = [val[0], end]
    }
    changeZskTime(val) {
        const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
        this.setZskDate = [val[0], end]
    }
    getZskDeleteData(){
        let week_day: string = this.deleteWeekDay.toString()
        // 设置上课日期
        let time: any = this.deleteZskDate
        let start_date: any = ''
        let end_date: any = ''
        if (time && time.length > 0) {
            start_date = Date.parse(time[0]) / 1000
            end_date = Date.parse(time[1]) / 1000
        }
        let data: any = {}
        if (this.deleteCourseControl === '1') {
            data = {
                'course_id': this.deleteCourseId,
                'reason': this.deleteCourseReason
            }
        } else if (this.deleteCourseControl === '3') {
            data = {
                'teacher_employee_id': this.teacherId,
                'course_id': this.deleteCourseId,
                'start_time': this.startTime,
                'course_number': this.course_number_delete,
                'reason': this.deleteCourseReason
            }
        } else {
            data = {
                'campus_id': this.campusId,
                'teacher_employee_id': this.teacherId,
                'start_time': this.startTime,
                'start_date': Number(start_date),
                'end_date': Number(end_date),
                'week_day': week_day,
                'start_hour': Number(this.startHour),
                'course_number': this.course_number_delete,
                'reason': this.deleteCourseReason
            }
        }
        return data
    }
    // 正式课移除准备 data
    deleteZskData() {
        const data = this.getZskDeleteData()
        this.clearCourse(data)
    }

    async getReserveStudentList(data){
        const response: any = await UserModule.getReserveStudent(data)
        if (response.code === 200) {
            this.reserveStudentList = response.data
        }
    }
    // 正式课移除弹窗true
    async deleteZskTrue() {
        if (this.deleteCourseControl === '1'){
            if (this.studentSignList.length > 0) {
                this.deleteZskStudent = true
            } else {
                // 直接delete
                this.deleteZskData()
            }
        }
        if (this.deleteCourseControl === '2') {
            // 获取批量时间段内的预约学员列表
            const data = this.getZskDeleteData()
            await this.getReserveStudentList(data)
            if(this.reserveStudentList.length == 0){
                this.deleteZskData()
                return
            }
            // 批量删除
            this.deletePackZskStudent = true
        }
    }

    // 正式课删除问询带学生名称
    handleZskClose() {
        this.deleteZskStudent = false
    }
    handlePackZskClose(){
        this.deletePackZskStudent = false;
    }
    handleZskTrue() {
        this.deleteZskData()
        this.handleZskClose()
        this.handlePackZskClose()
    }
    handleZskSkipTrue(){
        let data = this.getZskDeleteData()
        data.delete_type = 'skip'
        this.clearCourse(data)
        // 跳过
        this.handlePackZskClose()
    }

    //  试听课展示弹窗关闭
    handleShowStkClose() {
        this.dialogShowStk = false
        this.dialogShowZsk = false
        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    handleShowStkTrue() {
        // 问询试听课是否删除
        this.dialogDeleteStk = true
    }
    // 获取课程报名人员
    async getCourseSign() {
        const res: any = await UserModule.courseSign({ org_id: this.org_id, 'course_id': this.deleteCourseId })
        if (res.code === 200) {
            const data = res.data.list
            this.studentSignList = []
            for (var i = 0; i < data.length; i++) {
                if (data[i].sign_type != 2) {
                    this.studentSignList.push(data[i])
                }
            }
        }
    }
    // 编辑优先单个移除
    async deleteClass() {
        if (this.addType === 'zsk') {
            this.addZskTrue(2)
        } else {
            this.addStkTrue(2)
        }
    }

    // 试听课编辑
    async editAudition() {
        this.isDelete = true
        const res: any = await UserModule.getEditAudition({ org_id: this.org_id, 'course_id': this.deleteCourseId, 'types': 'edit_info' })
        if (res.code === 200) {
            this.getStkDesc = res.data.remark
            this.classRoomFirst = res.data.classroom_id
            this.classroomId = res.data.classroom_id
            this.getPeople = res.data.sale_employee_name
            this.sale_employee_id = res.data.sale_employee_id
            this.customer = res.data.customer_name
            this.customerId = res.data.customer_id
            this.business = res.data.business_name
            this.businessId = res.data.business_id
            this.addStkCampusId = res.data.campus_id
            this.getSktData()
        }
    }
    getSktData() {
        this.getClassroom(this.addStkCampusId)
        this.peopleList()
        this.nowCustomer()
        this.dialogAddStk = true
    }
    async nowCustomer() {
        const res: any = await UserModule.getNowCustomer({ name: this.customer, customer_id: this.customerId, phone: this.customer, org_id: this.org_id })
        if (res.code === 200) {
            let data = res.data.list[0]
            this.selectBusiness = data.values
            this.customerId = data.customer_id
        }
    }
    // 正式课编辑
    async editAuditionZsk() {
        this.isDelete = true
        this.dialogAddZsk = true

        const res: any = await UserModule.getEditAudition({ org_id: this.org_id, 'course_id': this.deleteCourseId, 'types': 'edit_info' })
        if (res.code === 200) {
            this.edit = false
            if (res.data.is_limit_student === 1) {
                this.isStudent = true
            } else if (res.data.is_limit_student === 2) {
                this.isStudent = false
            }
            if (res.data.subscript) {
                this.createLabel = '2'
            }

            this.courseTitleId = res.data.base_course_id
            this.selectBaseCourse = res.data.course_type_id
            this.selectBaseCourseName = res.data.course_type_name
            this.courseTitle = res.data.course_name

            this.classRoomFirst = res.data.classroom_id
            this.classroomId = res.data.classroom_id
            this.studentIds = []
            this.zskStudent = []
            for (var i = 0; i < this.studentSignList.length; i++) {
                this.zskStudent.push(this.studentSignList[i].student_name)
                this.studentIds.push(this.studentSignList[i].student_id)
            }

            this.zskRemark = res.data.remark
            this.classLevelId = res.data.course_level_id
            this.classLevel = res.data.course_level_name
            this.zskSubscript = res.data.subscript
            this.addCourseCampusId = res.data.campus_id
            this.addCourseCampusName = res.data.campus_name
            this.edit_show_student = false
            this.materialSelect = res.data.material_ids
            this.editBaseData()
        }
    }
    editBaseData() {
        this.getBaseCourse()
        this.getClassroom(this.addCourseCampusId)
        this.peopleList()
        this.getCourseLevel()
    }
    // 试听课无意向到店/爽约
    stkCancel(type, val) {
        if (val.sign_type === 4) {
            return false
        }
        if (val.sign_type === type) {
            this.editZskRemark = val.teacher_remark
        }
        if (type === 5) {
            this.addOccupyTitle = '确认无意向到店？'
        } else if (type === 6) {
            this.addOccupyTitle = '确认爽约？'
        }
        this.signType = type
        this.courseType = 2
        this.studentRowData = val
        this.dialogAddZys = true
    }

    // 正式课取消预约/学生旷课
    zskCancel(type, val) {
        if (val.sign_type === 1) {
            return false
        }
        if (val.sign_type === type) {
            this.editZskRemark = val.teacher_remark
        }
        if (type === 2) {
            this.addOccupyTitle = '是否将"' + val.student_name + '"设为取消预约？'
        } else if (type === 3) {
            this.addOccupyTitle = '是否将"' + val.student_name + '"设为学生旷课？'
        }
        this.dialogAddZys = true
        this.signType = type
        this.courseType = 1
        this.studentRowData = val
    }

    editCoursePop(val) {
        if (val.type === 'true') {
            let data: any = {
                teacher_remark: val.desc,
                sign_type: this.signType,
                id: this.studentRowData.id,
                course_type: this.courseType
            }
            this.signIn(data)
        } else {
            this.editZskRemark = ''
            this.dialogAddZys = false
        }
    }

    // 签到方法
    async signIn(data) {
        data.org_id = this.org_id
        const res: any = await UserModule.getClassSign(data)
        if (res.code === 200) {
            this.handleStkShopClose()
            this.handleStkSignClose()
            this.handleZskSignClose()
            this.stkShopReason = ''
            this.dialogShowZsk = false
            this.dialogAddZy = false
            this.dialogAddZys = false
            this.editZskRemark = ''
            this.$message({ message: res.message, type: 'success' })
        } else {
            this.$message({ message: res.message, type: 'error' })
        }

        this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
    }
    // 试听课关闭弹窗方法
    handleStkShopClose() {
        this.stkReason.desc = ''
        this.dialogShowStk = false
    }
    // 试听课签到
    stkSignIn(val) {
        if (val.sign_type === 4) {
            this.eidt_stk = true
            this.stkShopReason = val.teacher_remark
            const _this = this
            const stkStatus = (status) => {
                if (status === 4){
                    _this.stkRadioChecked4 = true    
                    _this.stkRadioChecked5 = false                
                    _this.stkRadioChecked6 = false
                }
                if (status === 5){
                    _this.stkRadioChecked5 = true
                    _this.stkRadioChecked4 = false
                    _this.stkRadioChecked6 = false
                }
                if (status === 6){
                    _this.stkRadioChecked6 = true
                    _this.stkRadioChecked4 = false
                    _this.stkRadioChecked5 = false
                }
            }
            stkStatus(val.business_status)
            if (val.business_status === 3) {
                this.customerIntention = 4
            } else {
                this.customerIntention = val.business_status
            }
            if (val.business_status === 5) {
                this.eidt_stk = true
            } else {
                this.eidt_stk = false
            }
        } else {
            if (val.business_status === 5) {
                this.eidt_stk = true
            } else {
                this.eidt_stk = false
            }
        }

        this.studentRowData = val
        this.order_itemValue['customer_id'] = val.customer_id
        this.dialogStkSign = true
    }
    // 试听课签到弹窗确认
    handleStkSignTrue() {
        let data = {
            business_status: this.customerIntention,
            course_type: 2,
            id: this.studentRowData.id,
            teacher_remark: this.stkShopReason,
            sign_type: 4
        }
        this.signIn(data)
    }
    createOrder() {
        this.dialogOrderAdd = true
    }
    // 试听课取消弹窗
    handleStkSignClose() {
        this.customerIntention = 4
        this.stkShopReason = ''
        this.dialogStkSign = false
    }
    // 正式课签到
    zskSignIn(type, val) {
        this.studentRowData = val
        this.getMaterial()
        this.getStudentLevel()
        this.itemId = val.id
        this.is_teach_plan = val.is_teach_plan

        if (val.sign_type === type) { // 编辑
            this.courseClick = true
            this.isNew = false
            this.getSignHistoryList(val)

        } else {  // 新建
            this.isNew = true
            this.courseClick = false
            this.getSignLastList()
        }
    }

    // 正式课签到取消
    handleZskSignClose() {
        this.dialogZskSign = false
        this.dialogZskNoSystem = false

        this.materialSelect = []
        this.studentRemark = ''
        this.teacherRemark = ''

        this.dialogZskNoSystem = false
        this.materialSelect = []
        this.studentRemarks = ''
        this.teacherRemark = ''
        this.stkReason.desc = ''
        this.addnotCustomer.teacherRemark = ''
        this.addnotCustomer.material_remark = ''
        this.addnotCustomer.subject_remark = ''
        this.addnotCustomer.materialSelect = []
        this.addnotCustomer.studentRemarks = ''
    }

    closeTableSign(val) {
        if (val.type) {
            val.data['id'] = this.studentRowData.id
            this.signIn(val.data)
        } else {
            this.dialogZskSign = false
        }
    }

    // 监测进度百分比
    changeSchedule(list) {
        let data = list.values
        var count = 0
        var len = data.length
        for (var i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
                count += 0
            } else if (data[i].status === 2) {
                count += 100 / len / 2
            } else if (data[i].status === 3) {
                count += 100 / len
            } else if (data[i].status === 4) {
                count += 100 / len
            }
        }
        list.percentage = count

        for (var i = 0; i < this.signPostData.length; i++) {
            if (this.signPostData[i].subject_id === list.subject_id) {
                this.signPostData[i] = list
            }
        }
    }
    // 正式课签到学员等级
    async getStudentLevel() {
        const res: any = await UserModule.studentLevel({ org_id: this.org_id })
        if (res.code === 200) {
            this.getStudentLevelList = res.data.list
        }
    }

    changeSelectMaterial(val) {
        let str: string = val.toString()
        this.materialSelectList = str
    }
    changeStudentLevel(val) {
        this.studentLevelId = val
    }

    async getCustomerList(val) {
        let restaurants = []
        const res: any = await UserModule.getCustomer({ name: '', phone: '', org_id: this.org_id })
        if (res.code === 200) {
            restaurants = res.data.list
            restaurants.forEach(item => {
                if (item.customer_id === val.data.id) {
                    this.customerId = item.customer_id
                    this.customer = item.customer_name
                    this.selectBusiness = item.values
                }
            })
        }
    }

    // 创建客户成功调用
    handleCustomerSaved(val) {
        this.customer = val.data.name
        this.getCustomerList(val)
    }
    // 创建客户
    createCustomer() {
        this.getCustomrList()
    }
    //  调起添加占用试听正式课程问询弹窗
    handlePop(val) {
        this.teacherSelect = val.values.teacher_name
        this.teacherId = val.values.id
        let str: string = ''
        this.getStudent(str)
        this.dialogVisible = true
    }

    //  添加占用课
    addOccupy(val) {
        if (val.type === 'true') {
            if (this.typeOccupy === 'edit') {
                let data = {
                    remark: val.desc,
                    id: this.occupyData.id,
                    course_type: 3 // 1正式2试听3占用
                }
                this.editCourseMethod(data)
            } else if (this.typeOccupy === 'add') {
                let data = {
                    'campus_id': this.campusId,
                    'start_time': this.startTime,
                    'course_type': 3, // 1正式2试听3占用
                    'remark': val.desc
                }
                this.addCurriculum(data)
            }
        }
        this.dialogAddZy = false
    }

    inquireOccupy(val) {
        if (val.type === 'close') {
            this.dialogInquiryZy = false
        } else if (val.type === 'delete') {
            this.dialogDeleteZy = true
            this.deleteCourseId = this.occupyData.id
        } else if (val.type === 'edit') {
            this.typeOccupy = 'edit'
            this.dialogAddZy = true
            this.addOccupyTitle = '编辑占用课'
            this.editZskRemark = this.occupyData.remark
        }
    }
    //  移除已占用
    handleZy(val) {
        this.deleteCourseId = val.id
        this.occupyData = val
        this.dialogInquiryZy = true
    }
    //  移除占用课
    deleteOccupy(val) {
        if (val === 'true') {
            let data = {
                'course_id': this.deleteCourseId
            }
            this.clearCourse(data)
        }
        this.dialogDeleteZy = false
    }
    //  移除正式课试听课占用课
    async clearCourse(data) {
        data.org_id = this.org_id
        const res: any = await UserModule.deleteCourse(data)
        if (res.code === 200) {
            this.dialogDeleteStk = false
            this.dialogAddStk = false
            this.dialogShowStk = false
            this.dialogShowZsk = false
            this.dialogDeleteZsk = false
            this.dialogInquiryZy = false
            this.deleteCourseReason = ''
            this.$message({ message: res.message, type: 'success' })
            this.getList(this.campusId, this.teacherEmployeeId, this.instrumentTypeId, this.eduTime)
        } else {
            this.deleteCourseReason = ''
            this.$message({ message: res.message, type: 'error' })
        }
    }
    //  添加试听课问询弹窗
    alertAuditionCourse() {
        this.addStkCampusId = this.campusId
        this.getClassroom(this.addStkCampusId)
        this.peopleList()
        this.dialogAddStk = true
    }

    // 历史签到记录
    async getSignHistoryList(val) {   // 编辑
        const res: any = await UserModule.getCourseSignLists({ 'org_id': this.org_id, 'course_id': this.deleteCourseId, 'student_id': this.studentRowData.student_id, 'types': 'history_list' })
        this.tableSignData = res.data
        this.signHistoryList = []
        this.signHistoryList.push(res.data)

        if (val.is_teach_plan === 1) {
            // 体系课签到
            this.dialogZskSign = true
        } else {
            // 非体系课签到
            this.dialogZskNoSystem = true
        }
    }
    //  第一次签到既要回显又要展示历史签到数据
    async getSignLastList() {  // 新建
        const res: any = await CourseModule.getCourseSignList({ 'student_id': this.studentRowData.student_id, 'course_id': this.deleteCourseId, 'types': 'last_sign', 'org_id': this.org_id })
        if (res.code === 200) {
            this.tableSignData = res.data
            this.signHistoryList = []
            this.signHistoryList.push(res.data)
            if (this.is_teach_plan == 1) {
                // 体系课签到
                this.dialogZskSign = true
            } else {
                // 非体系课签到
                this.dialogZskNoSystem = true
            }
        }
    }

    userHistoryObj: any = {}
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    // infoRules: any = infoRules
    loading: boolean = true
    teacherId: string = '' // teacher id
    addStk: any = {}
    campus: any = [];
    campusSelect: string = ''
    employee: any = []
    employeeSelect: any = []
    teacherSelect: string = '' // 雇员
    instrument: any = []
    instrumentSelect: any = []
    eduTime: any = Date.parse(<any>new Date())
    dialogVisible: boolean = false;
    campusId: string = '' // 校区id
    addCourseCampusId: string = '' // 添加课程校区id
    addCourseCampusName: string = ''
    addStkCampusId: string = '' // 选择试听课校区id
    teacherEmployeeId: string = '' // 雇员id
    instrumentTypeId: string = '' // 乐器类型id
    tableData: any[] = [] // list数据
    startTime: number = 0 // 创建课程表时间戳
    clickTime: string = '' // 创建课程表时间
    customer: string = '' // stk选择客户字段
    selectBusiness: any = [] // stk选择商机数据数组
    business: string = '' // stk选择商机数据 字符串
    classRoom: any = [] // stk获取校区对应课程
    classRoomFirst: string = '' // stk第一次校区对应课程名称
    getPeopleList: any = [] // stk获取人员list
    getPeople: string = '' // stk获取人员
    getStkDesc: string = '' // 获取stk备注
    customerId: string = '' // stk客户id
    businessId: string = '' // stk商机id
    classroomId: string = '' // stk教师id
    sale_employee_id: string = '' // stk销售人员id
    baseCourselist: any = [] // zsk课程种类list
    selectBaseCourse: string = '' // zsk课程种类
    selectBaseCourseName: string = ''
    courseTitleList: any = [] // zsk课程名list
    courseTitle: string = '' // zsk 课程名
    courseTitleId: string = '' // zsk 课程名id
    courseLevelList: any = [] // zsk 课程等级list
    classLevel: string = '' // zsk 课程等级
    classLevelId: string = '' // zsk 课程等级id
    materialList: any = [] // zsk 素材列表
    materialSelect: any = [] // zsk 素材
    createCourse: string = '1' // zsk 是否批量建课
    createLabel: string = '1' // zsk是否创建标签
    isStudent: boolean = false // zsk是否仅学员可见
    zskRemark: string = '' // zsk 备注
    zskSubscript: string = '' // zsk 角标
    setZskDate: any = [] // zsk 日期周期
    deleteZskDate: any = [] // 删除正式课日期
    zskWeekDay: any = [] // zsk 设置周几上课
    deleteWeekDay: any = [] // 删除正式课周几
    zskStudent: any = [] // zsk 学员查询
    studentList: any = [] // zsk 学员筛选list
    studentIds: any = [] // zsk 学员选择id
    startHour: string = '' // zsk 开始时间点数
    deleteCourseId: string = '' // 移除id
    dialogDeleteStk: boolean = false // 移除试听课弹窗
    dialogDeleteZsk: boolean = false // 移除正式课弹窗
    deletePackZskStudent: boolean = false // 批量删除弹窗
    typeOccupy: string = 'add'   // 是新增还是编辑占用课
    deleteCourseControl: string = '1' // 是否批量移除
    studentSignList: any = [] // 课程报名列表
    edit: boolean = true
    isDelete: boolean = false // 是否是编辑然后删除课程
    dialogAddStk: boolean = false
    dialogShowStk: boolean = false
    dialogShowZsk: boolean = false
    dialogAddZsk: boolean = false
    addType: string = 'stk' // 添加类型
    studentRowData: any = {} // 签到学生数据
    stkShopReason: string = '' // 试听课无意向到店原因
    stkReason: any = {
        desc: ''
    } // 正式课试听课取消原因
    signType: number = 0 // 签到类型  1，2，3，4，5，6
    courseType: number = 0 // 1正式 2试听 3占用
    customerIntention: number = 4 // 客户意向 4，5，6
    historyListArr: any = [] // 正式课签到数据item
    selectThemeList: any = [] // 正式课签到已选择主题
    selectThemeHistoryList: any = [] // 正式课历史签到已选择主题
    historyList: any = [] // 正式课历史签到数据
    historySelectlist: any = [] // 正式课签到数据已选择
    getSignInTime: string = '' // 签到时间
    getStudentLevelList: any = [] // 正式课签到学员等级
    teacherRemark: string = '' // 正式课签到老师备注
    studentRemark: string = '' // 正式课签到学生备注
    historySignInList: any = {} // 历史签到记录
    materialSelectList: string = '' // 正式课签到选择素材list
    studentLevelId: string = '' // 正式课选择学员等级id
    addCustomer: any = {} // 正式课签到
    dialogStkSign: boolean = false
    dialogZskSign: boolean = false
    dialogZskNoSystem: boolean = false // 非体系课签到
    rowArr: any[] = []
    historySignTime: string = '' // 历史签到记录title
    signPostData: any = [] // 正式课签到提交字符串
    deleteZskStudent: boolean = false // 正式课删除问询带学生名称
    hiddenData: boolean = false //是否隐藏空行
    historyRecord: boolean = false // 展示历史记录抽屉页
    history_course_id: string = ''
    is_show_course_record_info: boolean = false
    stkRadioChecked4 = true
    stkRadioChecked5 = false
    stkRadioChecked6 = false
    // 新建客户
    addZsk: any = {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        resource: '',
        desc: '',
        data3: []
    }
    dialogAddZy: boolean = false // 添加占用弹窗
    dialogAddZys: boolean = false // 添加占用弹窗
    dialogDeleteZy: boolean = false // 去除占用弹窗
    dialogInquiryZy: boolean = false // 问询占用弹窗
    occupyData: any = {} // 占用当前数据
    dialogAddStkData: any = {
        flag: false,
        time: '',
        teacher: '',
        campus: ''
    } // test addstkdata
    addOccupyTitle: string = '确认把该时间段设置为占用吗？'
    tableHeight: number = window.innerHeight - 170
    // 新增客户
    dialogAdd: boolean = false
    modifyHeader: any = []
    optionId: string = ''
    optionList: any = []
    isAddType: string = 'add'
    itemValue: any = {}
    pageName: string = ''
    allData: any = {}
    signHistoryList: any = []
    eidt_stk: boolean = false
    zsk_student_count: number = 0
    labelArr: any = [{'key': '9:00-10:00', 'hightColumn': 0}, {'key': '10:00-11:00', 'hightColumn': 0}, {'key': '11:00-12:00', 'hightColumn': 0}, {'key': '12:00-13:00', 'hightColumn': 0}, {'key': '13:00-14:00', 'hightColumn': 0}, {'key': '14:00-15:00', 'hightColumn': 0}, {'key': '15:00-16:00', 'hightColumn': 0}, {'key': '16:00-17:00', 'hightColumn': 0}, {'key': '17:00-18:00', 'hightColumn': 0}, {'key': '18:00-19:00', 'hightColumn': 0}, {'key': '19:00-20:00', 'hightColumn': 0}, {'key': '20:00-21:00', 'hightColumn': 0}, {'key': '21:00-22:00', 'hightColumn': 0}]
    editZskRemark: string = ''
    material_remark: string = ''
    addnotCustomer: any = {
        teacherRemark: '',
        subject_remark: '',
        materialSelect: [],
        studentRemarks: '',
        material_remark: ''
    } // 非体系课
    itemId: any = ''
    courseClick: boolean = false
    is_teach_plan: number = 1
    studentRemarks: string = ''
    zsk_title: string = ''  // 正式课title
    sign_types = ''
    is_tooltip_show: boolean = true
    is_tooltip_hide: boolean = false
    is_show_student_info: boolean = false
    student_info_id: string = ''

    business_page: any = {}
    business_upId: string = ''
    business_optionId: string = ''
    business_pageName: string = ''
    business_allData: any = []
    business_modifyHeader: any = []
    business_optionList: any = []
    business_itemValue: any = {}
    business_isAddType: string = 'edit'
    dialogBusinessAdd: boolean = false
    history_sign_time: string = ''
    sign_title: string = ''
    is_show_employee_info: boolean = false
    employee_info_id: string = ''
    total_course_title: any = {}
    course_number: number = 1
    course_number_delete: number = 1
    tableSignData: any = {}
    isNew: boolean = true
    // 新建订单
    dialogOrderAdd: boolean = false
    order_modifyHeader: any = []
    order_optionList: any = []
    order_optionId: string = ''
    order_isAddType: string = 'add'
    order_itemValue: any = {}
    order_allData: any = []
    edit_show_student: boolean = false
    deleteCourseReason: string = ''
    allSchool: any = []
    // 约课
    dialogReserveCourse: boolean = false
    reserveCourseId: string = null
    baseCourseByCourseList: any = []
    courseObj: any = {}
    reserveStudentList: any = []
    selectBaseCourseID: string = null
}
